﻿

	 import { SearchFilter } from '@models/search-filters/SearchFilter';
    
    export class ChatUserSearchFilter extends SearchFilter {
        
    }
